import { createSlice } from '@reduxjs/toolkit';

const NAME = 'scheduling';

const initialState = {
  loading: false,
  error: { hasError: false, state: NAME },
  serverError: { hasError: false, state: NAME },
  allocations: [],
  engagements: [],
  professionals: []
};

export const schedulingSlice = createSlice({
  name: NAME,
  initialState,
  reducers: {
    setAllocations: (state, action) => {
      state.allocations = action.payload;
    },
    setEngagements: (state, action) => {
      state.engagements = action.payload;
    },
    setProfessionals: (state, action) => {
      state.professionals = action.payload;
    },
    setServerError: (state, action) => {
      const { status, message, type } = action.payload;
      state.serverError.hasError = true;
      state.serverError.code = status;
      state.serverError.message = message;
      state.serverError.type = type;
    },
    setError: (state, action) => {
      const { status, message, type } = action.payload;
      state.error.hasError = true;
      state.error.code = status;
      state.error.message = message;
      state.error.type = type;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    cleanErrors: state => {
      state.serverError = { hasError: false, state: NAME };
      state.error = { hasError: false, state: NAME };
    },
    cleanState: state => {
      state = { ...initialState };
    }
  }
});

export const schedulingActions = schedulingSlice.actions;

export default schedulingSlice;
